export default __webpack_public_path__ + "static/media/elk.74335837.webp";